import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "media-field" }
const _hoisted_2 = { class: "ontos-field-label" }
const _hoisted_3 = {
  key: 1,
  class: "media-field-audio d-flex align-center px-3"
}
const _hoisted_4 = {
  key: 0,
  class: "ml-3 text-caption text-grey"
}
const _hoisted_5 = { class: "text-body-2 mt-2" }
const _hoisted_6 = ["accept"]
const _hoisted_7 = {
  key: 4,
  class: "text-caption text-grey mt-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_ontos_header_action = _resolveComponent("ontos-header-action")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _component_ontos_audio_player = _resolveComponent("ontos-audio-player")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_messages = _resolveComponent("v-messages")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.label), 1),
    (_ctx.busy)
      ? (_openBlock(), _createBlock(_component_v_sheet, {
          key: "busy",
          border: "",
          rounded: "",
          class: "media-field-box d-flex align-center justify-center",
          style: _normalizeStyle(_ctx.boxStyle)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary",
              size: "36"
            })
          ]),
          _: 1
        }, 8, ["style"]))
      : (_ctx.hasValue)
        ? (_openBlock(), _createBlock(_component_v_sheet, {
            key: "filled",
            border: "",
            rounded: "",
            class: "media-field-box media-field-filled",
            style: _normalizeStyle(_ctx.boxStyle),
            onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.hover = true)),
            onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hover = false))
          }, {
            default: _withCtx(() => [
              (_ctx.type === 'image')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_v_img, {
                      src: _ctx.value,
                      alt: _ctx.label,
                      "aria-label": _ctx.label,
                      height: "100%"
                    }, null, 8, ["src", "alt", "aria-label"]),
                    (!_ctx.readonly)
                      ? (_openBlock(), _createBlock(_component_v_overlay, {
                          key: 0,
                          contained: "",
                          "model-value": _ctx.hover || !_ctx.canHover,
                          opacity: "0.55",
                          "z-index": "1",
                          class: "align-center justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ontos_header_action, {
                              icon: "mdi-file-replace",
                              label: _ctx.$tt('field.change'),
                              "always-label": "",
                              class: "mr-2",
                              onClick: _ctx.pick
                            }, null, 8, ["label", "onClick"]),
                            _createVNode(_component_ontos_header_action, {
                              icon: "mdi-delete",
                              label: _ctx.$tt(_ctx.kind.removeKey),
                              "always-label": "",
                              onClick: _ctx.remove
                            }, null, 8, ["label", "onClick"])
                          ]),
                          _: 1
                        }, 8, ["model-value"]))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_ontos_audio_player, {
                      src: _ctx.value,
                      label: _ctx.label
                    }, null, 8, ["src", "label"]),
                    (_ctx.durationText)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.durationText), 1))
                      : _createCommentVNode("", true),
                    (!_ctx.readonly)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createVNode(_component_v_btn, {
                            size: "small",
                            variant: "text",
                            icon: "",
                            class: "ml-auto",
                            title: _ctx.$tt('field.change'),
                            onClick: _ctx.pick
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, { size: "small" }, {
                                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                  _createTextVNode("mdi-file-replace", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["title", "onClick"]),
                          _createVNode(_component_v_btn, {
                            size: "small",
                            variant: "text",
                            icon: "",
                            title: _ctx.$tt(_ctx.kind.removeKey),
                            onClick: _ctx.remove
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, { size: "small" }, {
                                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                  _createTextVNode("mdi-delete", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["title", "onClick"])
                        ], 64))
                      : _createCommentVNode("", true)
                  ]))
            ]),
            _: 1
          }, 8, ["style"]))
        : (_openBlock(), _createBlock(_component_v_sheet, {
            key: "empty",
            border: "",
            rounded: "",
            style: _normalizeStyle(_ctx.boxStyle),
            class: _normalizeClass(["media-field-box media-field-drop d-flex flex-column align-center justify-center text-center pa-4", {'media-field-over': _ctx.over, 'media-field-disabled': _ctx.readonly}]),
            onClick: _ctx.pick,
            onDragover: _withModifiers(_ctx.onDragOver, ["prevent"]),
            onDragleave: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.over = false), ["prevent"])),
            onDrop: _withModifiers(_ctx.onDrop, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                size: "40",
                color: "grey"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.kind.emptyIcon), 1)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.readonly ? _ctx.$tt(_ctx.kind.emptyKey) : _ctx.$tt(_ctx.kind.dropHintKey)), 1)
            ]),
            _: 1
          }, 8, ["style", "class", "onClick", "onDragover", "onDrop"])),
    _createElementVNode("input", {
      ref: "file",
      type: "file",
      accept: _ctx.kind.accept,
      class: "media-field-input",
      onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onPick && _ctx.onPick(...args)))
    }, null, 40, _hoisted_6),
    (_ctx.shownError)
      ? (_openBlock(), _createBlock(_component_v_messages, {
          key: 3,
          active: "",
          messages: _ctx.shownError,
          color: "error",
          class: "mt-1",
          role: "alert"
        }, null, 8, ["messages"]))
      : (!_ctx.readonly)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.hint), 1))
        : _createCommentVNode("", true)
  ]))
}